import React, {Fragment, useRef} from 'react';
import {Form, Field} from 'react-final-form';
import {Popup, Text, Select, Explanation_text} from '../../../components';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import {connect} from 'react-redux';

function Credit_distribution_popup(props){

  function onSubmit(params){
    props.updateCreditsDistribution(params);
  }


  let initial_values={user_mapping:[]}; if(props.initial_values!=undefined){initial_values={user_mapping:props.initial_values}}

  for(let uw_key of Object.keys(props.workspace.user_workspaces)){
    let uw=props.workspace.user_workspaces[uw_key];
    initial_values.user_mapping.push({user_workspace_id:uw.id, credit_limit:uw.workspace_credits_limit})
  }
  return(
    <Form
      initialValues={initial_values}
      onSubmit={onSubmit}
      mutators={{
        ...arrayMutators
      }}
      {...props}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
        <Popup accept_button='Save' accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose();}} handleClose={props.handleClose} always_open title='payment_credit_limits_popup_title' content={
          <div style={{width:'95vw', maxWidth:'600px'}}>
          <FieldArray name='user_mapping'>
          {({ fields }) =>{
            let pre_users=[]; let check_users=[];
            for(let f of fields.value){if(!check_users.includes(f.user_workspace_id)){check_users.push(f.user_workspace_id);}}
            for(let u_k in props.workspace.user_workspaces){let u=props.workspace.user_workspaces[u_k]; if(u.invisible!=true && !check_users.includes(u.id)){pre_users.push({id:u.id, name:u.first_name+' '+u.last_name});}}

            return(
          <div style={{width:'95vw', maxWidth:'600px'}}>
            <Grid container style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'20px', marginBottom:'20px'}}>
              <Grid item xs={7}><Typography style={{width:'calc(100% - 20px)', marginLeft:'0px'}} color='primary'><Explanation_text inline text='payment_credits_limits_username_label'/></Typography></Grid>
              <Grid item xs={5}><Typography style={{width:'calc(100% - 20px)', marginLeft:'0px'}} color='primary'><Explanation_text inline text='payment_credits_limits_monthly_limit_label'/></Typography></Grid>
            </Grid>
            {fields.map((name, index) => (
              <Grid container style={{width:'calc(100% - 40px)', marginLeft:'20px', marginBottom:'20px'}}>
                <Grid item xs={6}><Field name={`${name}.user_workspace_id`}>{(f)=>{return(<Typography style={{paddingTop:'3px'}}>{props.workspace.user_workspaces[f.input.value].first_name+' '+props.workspace.user_workspaces[f.input.value].last_name}</Typography>)}}</Field></Grid>
                <Grid item xs={1}/>
                <Grid item xs={5}><Field name={`${name}.credit_limit`}>{(f_c)=>{return(<div style={{marginTop:'10px'}}><TextField type='number' size='small' color='transparent' name={`${name}.credit_limit`} value={f_c.input.value} onChange={(e)=>{let original=(f_c.input.value=='')?0:Number(f_c.input.value); let new_=e.target.value; let diff=new_ - original; f_c.input.onChange(Number(new_));}}/></div>)}}</Field></Grid>
              </Grid>
          ))}
          </div>
        )}}
          </FieldArray>
          </div>
        }/>
        </form>
      )}
    </Form>
  )
}

export default connect(ss, dd)(Credit_distribution_popup)


function ss(state){
  return{
    workspace:(state.workspaces.data==undefined)?undefined:state.workspaces.data[state.workspaces.current_workspace_id],
    refresh:state.workspaces.data[state.workspaces.current_workspace_id].refresh
  }
}

function dd(dispatch){
  return{
    updateCreditsDistribution:(params)=>{dispatch({type:'REQUEST_UPDATE_CREDITS_DISTRIBUTION', payload:params});}
  }
}
